<template>
  <section
    class="bg-gradient-to-r from-gray-100/70 to-gray-100 relative xl:py-24 py-16"
  >
    <div class="absolute top-0 inset-x-0 hidden sm:block">
      <img
        src="assets/images/shapes/white-wave.svg"
        alt="svg"
        class="w-full -scale-x-100"
      />
    </div>

    <div class="py-5">
      <div class="container" data-aos="fade-up" data-aos-duration="300">
        <div class="text-center">
          <h1 class="text-3xl/tight font-medium mt-3 mb-4">
            {{ partnerStore.partnerHeadline }}
          </h1>
          <p class="text-gray-500">
            {{ partnerStore.partnerDescription }}
          </p>
        </div>

        <div
          class="flex flex-wrap items-center justify-center lg:gap-24 gap-10 mt-14"
        >
          <div v-for="(partner, index) in partnerStore.partners" :key="index">
            <img :src="partner.Logo" class="h-20" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { usePartnerStore } from "@/stores/partnerStore";

const partnerStore = usePartnerStore();
</script>
